/**
 * Sticky add-to-cart:
 * - Mobile: after size controls load, when the size block is fully above the area reserved for the
 *   fixed bar (bottom of gate clears the bar height) so size buttons are not covered.
 * - Desktop: after size controls load, when the main gallery/slider (`.product__main-photos`) has
 *   scrolled past the reveal line so the bar does not cover product images.
 */
(function () {
  var stickyBarInitialized = new WeakSet();

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function getDocScrollY() {
    return (
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    );
  }

  function getViewportHeight() {
    if (window.visualViewport && window.visualViewport.height) {
      return window.visualViewport.height;
    }
    return window.innerHeight;
  }

  /** Matches theme breakpoints (`sticky-product-atc.css` uses 769px for desktop bar width). */
  function isDesktopStickyViewport() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 769px)').matches;
  }

  /**
   * Desktop: horizontal line from top of viewport (VH fraction). Gallery is “past” when its
   * bottom edge is at or above this line — same idea as the original Impulse-style sticky reveal.
   */
  var STICKY_ATC_DESKTOP_GALLERY_REVEAL_VH_PCT = 0.85;

  /**
   * theme.Currency.formatMoney wraps cents in <sup> when superScriptPrice is on.
   * Flatten to normal decimals; drop whole-dollar .00 / ,00 so "$125<sup>00</sup>" → "$125".
   */
  function normalizeStickyPriceHtml(html) {
    if (!html || typeof html !== 'string') return html;
    var fmt = theme.settings && theme.settings.moneyFormat ? theme.settings.moneyFormat : '';
    var useComma = fmt.indexOf('amount_with_comma_separator') !== -1;
    var dec = useComma ? ',' : '.';
    return html.replace(/<sup>(\d{2})<\/sup>/gi, function (_, cents) {
      if (cents === '00') return '';
      return dec + cents;
    });
  }

  function syncPrice(priceEl, variant) {
    if (!priceEl || !variant || typeof theme === 'undefined' || !theme.Currency) return;
    var price = normalizeStickyPriceHtml(
      theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)
    );
    if (variant.compare_at_price > variant.price) {
      var cmp = normalizeStickyPriceHtml(
        theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat)
      );
      priceEl.innerHTML =
        '<span class="sticky-product-atc__price-compare">' +
        cmp +
        '</span> <span class="sticky-product-atc__price-current on-sale">' +
        price +
        '</span>';
    } else {
      priceEl.innerHTML = '<span class="sticky-product-atc__price-current">' + price + '</span>';
    }
  }

  function syncImage(imgEl, variant) {
    if (!imgEl || !variant) return;
    var src = null;
    if (variant.featured_image && variant.featured_image.src) src = variant.featured_image.src;
    if (!src && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      src = variant.featured_media.preview_image.src;
    }
    if (!src) return;
    if (imgEl.getAttribute('src') === src) return;
    imgEl.setAttribute('src', src);
  }

  function getMainAddButton(section) {
    return qs(section, '[data-add-to-cart]');
  }

  function getSelectSizePlaceholder(section) {
    return qs(section, '.add-to-cart.onload-select--size');
  }

  /** Matches theme PDP: user must choose a size before ATC is real (placeholder or no-selected-state). */
  function stickySizeStillPending(section) {
    if (!section) return true;
    if (qs(section, '.add-to-cart.onload-select--size')) return true;
    if (qs(section, '.variant-wrapper.no-selected-size')) return true;
    return false;
  }

  function syncButton(section, btn) {
    if (!btn) return;
    var placeholder = getSelectSizePlaceholder(section);
    var mainBtn = getMainAddButton(section);
    if (stickySizeStillPending(section)) {
      console.log(placeholder);
      if (placeholder) {
        var span = qs(placeholder, 'span');
        btn.textContent = 'Add to cart';
      } else {
        var phMain = getMainAddButton(section);
        var phText = phMain ? qs(phMain, '[data-add-to-cart-text]') : null;
        btn.textContent = 'Add to cart';
      }
      btn.disabled = false;
      btn.classList.remove('disabled');
      btn.classList.remove('btn--loading');
      return;
    }
    if (!mainBtn) return;
    var textEl = qs(mainBtn, '[data-add-to-cart-text]');
    btn.textContent = textEl ? textEl.textContent.trim() : mainBtn.textContent.trim();
    btn.disabled = mainBtn.disabled;
    btn.classList.toggle('disabled', mainBtn.classList.contains('disabled'));
    btn.classList.toggle('btn--loading', mainBtn.classList.contains('btn--loading'));
  }

  function findSizeWrap(section) {
    return (
      qs(section, '.variant-input-wrap[name="Size"]') ||
      qs(section, '.variant-input-wrap[data-handle="size"]')
    );
  }

  function findSelectSizeGate(section) {
    var sizeWrap = findSizeWrap(section);
    if (sizeWrap) {
      return sizeWrap.closest('.variant-wrapper') || sizeWrap;
    }
    return qs(section, '.variant-wrapper.size-chart_flex');
  }

  function sizeControlsFinishedLoading(section) {
    var sizeWrap = findSizeWrap(section);
    if (!sizeWrap) {
      return true;
    }
    return !!sizeWrap.querySelector('input[data-variant-input], select[data-variant-input]');
  }

  function escapeForAttributeId(id) {
    if (!id) return id;
    return typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(id) : id;
  }

  function readLabelTextForRadio(wrap, radio) {
    if (!radio || !radio.id) return '';
    var forSel = 'label[for="' + escapeForAttributeId(radio.id) + '"]';
    var lab = wrap.querySelector(forSel);
    if (lab) {
      return String(lab.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    return '';
  }

  /**
   * Prefers visible duplicate (US) label when EU/US custom block is active; else real <label> or value.
   * Variant option `value` stays the canonical EU / stock-keeping value; duplicate row shows US text.
   */
  function readSelectedSizeValue(section) {
    var wrap = findSizeWrap(section);
    if (!wrap) return '';

    var radio = wrap.querySelector('input[type="radio"]:checked');
    var customBlock = qs(wrap, '.custom-eu-us-sizes');

    if (customBlock && customBlock.classList.contains('active')) {
      var activeDup = customBlock.querySelector('.variant__button-label.activeLabel');
      if (activeDup) {
        var us = String(activeDup.textContent || '')
          .replace(/\s+/g, ' ')
          .trim();
        if (us) return us;
      }
      if (radio && radio.id) {
        var dataForAttr = escapeForAttributeId(radio.id);
        var dupById = customBlock.querySelector('.variant__button-label[data-for="' + dataForAttr + '"]');
        if (dupById) {
          var t2 = String(dupById.textContent || '')
            .replace(/\s+/g, ' ')
            .trim();
          if (t2) return t2;
        }
      }
    }

    if (radio) {
      var fromDefaultLabel = readLabelTextForRadio(wrap, radio);
      if (fromDefaultLabel) return fromDefaultLabel;
      if (radio.value) return String(radio.value).trim();
    }

    var sel = wrap.querySelector('select[data-variant-input]');
    if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
      return String(sel.selectedOptions[0].textContent || sel.value || '').trim();
    }
    return '';
  }

  /**
   * PDPs that use "Select a size" + no-selected-size: don't show the sticky size label on first paint
   * (Shopify may still have a default variant checked). Show the label only after the shopper interacts
   * (click or change on size controls), tracked via data-sticky-atc-size-confirmed on the section.
   */
  function shouldShowStickySizeLabel(section, hadSelectSizePickerAtInit) {
    if (!hadSelectSizePickerAtInit) return true;
    return section.getAttribute('data-sticky-atc-size-confirmed') === 'true';
  }

  function markStickySizeConfirmed(section) {
    section.setAttribute('data-sticky-atc-size-confirmed', 'true');
  }

  function isStickySizeControlInteraction(target, wrap) {
    if (!target || !wrap || !wrap.contains(target)) return false;
    return !!target.closest(
      [
        'input[data-variant-input][name="Size"]',
        'input[type="radio"][name="Size"]',
        '.variant-input-wrap[name="Size"] .variant__button-label',
        '.variant-input-wrap[name="Size"] label.variant__button-label',
        '.size-view-btn',
        '.wide-view-btn'
      ].join(',')
    );
  }

  function syncSizeRow(rowEl, valueEl, section, hadSelectSizePickerAtInit) {
    if (!rowEl || !valueEl) return;
    if (stickySizeStillPending(section)) {
      rowEl.hidden = true;
      rowEl.setAttribute('aria-hidden', 'true');
      valueEl.textContent = '';
      return;
    }
    if (!shouldShowStickySizeLabel(section, hadSelectSizePickerAtInit)) {
      rowEl.hidden = true;
      rowEl.setAttribute('aria-hidden', 'true');
      valueEl.textContent = '';
      return;
    }
    var val = readSelectedSizeValue(section);
    if (!val) {
      rowEl.hidden = true;
      rowEl.setAttribute('aria-hidden', 'true');
      valueEl.textContent = '';
      return;
    }
    rowEl.hidden = false;
    rowEl.setAttribute('aria-hidden', 'false');
    valueEl.textContent = val;
  }

  function initialVariantFromDom(section, form) {
    var sel = form ? qs(form, '[data-product-select]') : null;
    if (!sel) return null;
    var id = parseInt(sel.value, 10);
    var jsonEl = qs(section, '[data-variant-json]');
    if (!jsonEl) return null;
    try {
      var variants = JSON.parse(jsonEl.innerHTML);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
    } catch (e) {}
    return null;
  }

  function initBar(root) {
    if (stickyBarInitialized.has(root)) return;

    var sectionId = root.getAttribute('data-product-section-id');
    if (!sectionId) return;
    var section = document.getElementById(sectionId);
    if (!section) return;

    var btn = qs(root, '[data-sticky-atc-trigger]');
    var priceEl = qs(root, '[data-sticky-atc-price]');
    var imgEl = qs(root, '[data-sticky-atc-image]');
    var sizeRowEl = qs(root, '[data-sticky-atc-size-row]');
    var sizeValueEl = qs(root, '[data-sticky-atc-size-value]');
    var formId = root.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;

    if (!btn) return;

    stickyBarInitialized.add(root);

    /* True when this PDP uses the select-a-size placeholder / no-selected-size UX (may still have a default variant checked). */
    var hadSelectSizePickerAtInit = !!(
      getSelectSizePlaceholder(section) || qs(section, '.variant-wrapper.no-selected-size')
    );

    function updatePadding() {
      if (!root.classList.contains('sticky-product-atc--visible')) {
        document.documentElement.style.setProperty('--sticky-product-atc-h', '0px');
        return;
      }
      document.documentElement.style.setProperty('--sticky-product-atc-h', root.offsetHeight + 'px');
    }

    function hideStickyBar() {
      root.classList.remove('sticky-product-atc--visible');
      document.body.classList.remove('sticky-product-atc--active');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.setProperty('--sticky-product-atc-h', '0px');
    }

    function revealStickyBar() {
      root.classList.add('sticky-product-atc--visible');
      document.body.classList.add('sticky-product-atc--active');
      root.setAttribute('aria-hidden', 'false');
      updatePadding();
    }

    function getMobileStickyAtcReserveHeight() {
      if (root && root.offsetHeight > 30) {
        return root.offsetHeight;
      }
      /**
       * Fallback before full layout: full-bleed mobile bar ≈ 52px btn + 28px padding + safe area headroom
       * (see `.sticky-product-atc--size-pending .sticky-product-atc__inner` in CSS).
       */
      return 120;
    }

    function userHasReachedBottomOfSizeSection() {
      var vh = getViewportHeight();
      var gate = findSelectSizeGate(section);
      if (!gate) {
        var photos = section.querySelector('.product__main-photos');
        var fallbackLine = vh * 0.85;
        if (!photos) return getDocScrollY() >= fallbackLine;
        return photos.getBoundingClientRect().bottom <= fallbackLine;
      }
      var gateRect = gate.getBoundingClientRect();
      /**
       * The bottom of the size block must sit *above* the fixed sticky bar, not in the same band as
       * the viewport bottom — otherwise the bar covers the last rows of size buttons. Reserve the
       * bar’s own height (measured) plus a small gap.
       */
      var barH = getMobileStickyAtcReserveHeight();
      var gapPx = 8;
      var clearLine = vh - barH - gapPx;
      return gateRect.bottom <= clearLine;
    }

    /**
     * Desktop: show after the main image slider/gallery has scrolled past the reveal line so
     * the sticky bar does not obscure the gallery.
     */
    function userHasPassedMainProductGallery() {
      var vh = getViewportHeight();
      var lineY = vh * STICKY_ATC_DESKTOP_GALLERY_REVEAL_VH_PCT;
      var photos = section.querySelector('.product__main-photos');
      if (!photos) {
        return getDocScrollY() >= lineY;
      }
      return photos.getBoundingClientRect().bottom <= lineY;
    }

    function shouldRevealStickyBar() {
      if (!sizeControlsFinishedLoading(section)) {
        return false;
      }
      if (isDesktopStickyViewport()) {
        return userHasPassedMainProductGallery();
      }
      return userHasReachedBottomOfSizeSection();
    }

    var scrollRaf = 0;
    function updateScrollGate() {
      if (shouldRevealStickyBar()) {
        if (!root.classList.contains('sticky-product-atc--visible')) {
          revealStickyBar();
        } else {
          updatePadding();
        }
      } else {
        // if (root.classList.contains('sticky-product-atc--visible')) {
        //   hideStickyBar();
        // } else {
        //   document.documentElement.style.setProperty('--sticky-product-atc-h', '0px');
        // }
      }
    }

    function onWindowScroll() {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = 0;
        updateScrollGate();
      });
    }

    if (!root.hasAttribute('data-sticky-atc-scroll-wired')) {
      root.setAttribute('data-sticky-atc-scroll-wired', 'true');
      window.addEventListener('scroll', onWindowScroll, { passive: true });
      window.addEventListener('resize', onWindowScroll, { passive: true });
    }

    function refreshStickyLayout() {
      syncSizeRow(sizeRowEl, sizeValueEl, section, hadSelectSizePickerAtInit);
      syncButton(section, btn);
      root.classList.toggle('sticky-product-atc--size-pending', stickySizeStillPending(section));
      var v = sizeValueEl && String(sizeValueEl.textContent || '').trim();
      if (v) {
        var h = document.querySelector('.size_heading');
        var s = document.querySelector('.selected_size');
        if (h) h.textContent = 'Size';
        if (s) s.textContent = v;
      }
      updateScrollGate();
      updatePadding();
    }

    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'true');
    updateScrollGate();

    function onVariantChange(evt) {
      requestAnimationFrame(function () {
        if (evt && evt.detail && evt.detail.variant) {
          syncPrice(priceEl, evt.detail.variant);
          syncImage(imgEl, evt.detail.variant);
        } else if (priceEl) {
          var domPrice = qs(section, '[data-product-price]');
          if (domPrice) {
            priceEl.innerHTML = normalizeStickyPriceHtml(domPrice.innerHTML);
          }
        }
        refreshStickyLayout();
      });
    }

    section.addEventListener('variantChange', onVariantChange);

    function runStickySizePendingPathInner() {
      var desktopWidth =
        typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 770px)').matches;
      if (desktopWidth && typeof window.taosScrollToColorForSize === 'function') {
        window.taosScrollToColorForSize(section);
      } else if (typeof window.taosShowSizeRequiredAndScroll === 'function') {
        window.taosShowSizeRequiredAndScroll(section);
      } else if (typeof window.taosScrollSizesIntoView === 'function') {
        window.taosScrollSizesIntoView(section);
      } else {
        var placeholderFallback = getSelectSizePlaceholder(section);
        if (placeholderFallback) {
          placeholderFallback.click();
        } else {
          var sizeBlock = qs(section, '.variant-input-wrap[name="Size"]');
          if (sizeBlock) {
            sizeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    }
    function isCoarsePointer() {
      try {
        return window.matchMedia('(pointer: coarse)').matches;
      } catch (e) {
        return typeof window.ontouchstart !== 'undefined';
      }
    }
    function runStickySizePendingPath() {
      if (typeof window.taosStabilizeDocumentScroll === 'function') {
        window.taosStabilizeDocumentScroll();
      }
      if (isCoarsePointer()) {
        window.requestAnimationFrame(function () {
          runStickySizePendingPathInner();
        });
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          runStickySizePendingPathInner();
        });
      });
    }
    /*
      Mobile / fixed bar: passive touchstart + touch-action:manipulation (CSS) improve hit
      testing. If iOS still drops the synthetic `click` after touch, `pointerup` (touch) runs
      the same path; the following `click` is ignored via suppressStickyClick.
     */
    var suppressStickyClick = false;
    btn.addEventListener('touchstart', function () {}, { passive: true, capture: false });
    btn.addEventListener('pointerdown', function () {}, { passive: true, capture: false });
    function handleStickyAtcActivate() {
      if (stickySizeStillPending(section)) {
        runStickySizePendingPath();
        return;
      }
      if (typeof window.taosStabilizeDocumentScroll === 'function') {
        window.taosStabilizeDocumentScroll();
      }
      var main = getMainAddButton(section);
      if (!main || main.disabled) {
        return;
      }
      if (isCoarsePointer()) {
        window.requestAnimationFrame(function () {
          main.click();
        });
        return;
      }
      console.log("main",main);
      main.click();
    }
    btn.addEventListener(
      'pointerup',
      function (e) {
        if (e.button !== 0) return;
        if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
        if (!isCoarsePointer()) return;
        if (e.target !== btn && !btn.contains(e.target)) return;
        suppressStickyClick = true;
        window.requestAnimationFrame(function () {
          handleStickyAtcActivate();
          window.setTimeout(function () {
            suppressStickyClick = false;
          }, 400);
        });
      },
      false
    );
    function onStickyAtcClick(e) {
      if (suppressStickyClick) {
        e.preventDefault();
        e.stopImmediatePropagation();
        suppressStickyClick = false;
        return;
      }
      handleStickyAtcActivate();
    }
    btn.addEventListener('click', onStickyAtcClick, true);

    var cv = qs(section, '[data-current-variant-json]');
    if (cv) {
      try {
        var v = JSON.parse(cv.innerHTML);
        syncPrice(priceEl, v);
        syncImage(imgEl, v);
      } catch (e) {}
    } else if (form) {
      var iv = initialVariantFromDom(section, form);
      if (iv) {
        syncPrice(priceEl, iv);
        syncImage(imgEl, iv);
      }
    }

    refreshStickyLayout();

    section.addEventListener(
      'change',
      function (e) {
        var wrap = findSizeWrap(section);
        if (!wrap || !wrap.contains(e.target)) return;
        if (e.target && e.target.getAttribute && e.target.getAttribute('name') === 'Size') {
          markStickySizeConfirmed(section);
        }
        refreshStickyLayout();
      },
      true
    );

    /*
      Bubble phase: runs after theme's click handlers remove no-selected-size / placeholder.
      Marks explicit size choice so the label can show even when re-clicking the same size (no change event).
    */
    section.addEventListener('click', function (e) {
      var wrap = findSizeWrap(section);
      if (!isStickySizeControlInteraction(e.target, wrap)) return;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          markStickySizeConfirmed(section);
          refreshStickyLayout();
        });
      });
    });

    refreshStickyLayout();

    var ro = new ResizeObserver(function () {
      updateScrollGate();
    });
    ro.observe(root);

    var mainBtn = getMainAddButton(section);
    if (mainBtn) {
      var btnObs = new MutationObserver(function () {
        refreshStickyLayout();
      });
      btnObs.observe(mainBtn, {
        attributes: true,
        subtree: true,
        childList: true,
        characterData: true,
        attributeFilter: ['class', 'disabled']
      });
    }

    window.addEventListener('resize', updatePadding, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-sticky-product-atc]').forEach(function (root) {
      if (stickyBarInitialized.has(root)) return;
      initBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('product:swatch-content-updated', init);
})();
